import React from "react"
import styled from "styled-components"
import { Input, Form } from "antd"
import { getColor } from "../../../../components/Color"
import { media } from "../../../../components/mediaStylesNew"
import CheckIcon from "../CheckIcon"
import ErrorIcon from "../ErrorIcon"
import Question from "../Question"

const TextIcon = styled.div`
  font-family: Recife Text, serif;
  font-weight: 700;
  font-size: 20px;
`

const TextInput = styled(Input)`
  max-width: 100%;

  input {
    padding: 20px;
    padding-left: 35px !important;
    font-family: GT America, sans-serif;
    font-size: 16px;

    &:focus,
    &:hover {
      border-color: ${getColor("primary", 0.6)} !important;
      box-shadow: none;
    }
  }

  ${media.largerPhone`
    max-width: 300px;
    `}
`

const FormItem = styled(Form.Item)`
  position: relative;

  .ant-form-explain {
    font-family: GT America, sans-serif;
    position: absolute !important;
    bottom: -25px !important;
  }
`

export default class TextQuestionType extends React.Component {
  state = {
    isValid: null,
  }

  onValueChange = () => {
    // Check whether the value is valid
    this.props.validateFields([this.props.question.identifier], error => {
      if (error == null) {
        this.setState({ isValid: true })
      } else {
        this.setState({ isValid: false })
      }
    })
  }

  componentDidMount() {
    try {
      this.props.focus && this.input && this.input.focus()
    } catch (err) {}
  }

  render() {
    const { question, getFieldDecorator } = this.props
    return (
      <div>
        <Question {...question} focus={this.props.focus} />
        {getFieldDecorator && (
          <FormItem>
            {getFieldDecorator(question.identifier, {
              initialValue: this.props.value,
              validateFirst: true,
              // Remove points and commas
              rules: [
                {
                  required: this.props.question.required,
                  message: "Bitte ausfüllen",
                },
                {
                  pattern: /^[-]{0,1}[,\d]*$/,
                  message: "Es sind nur Zahlen und Kommas erlaubt",
                },
              ],
              trigger: "valueChanged",
            })(
              <InputFieldWrapper
                placeholder={this.props.placeholder}
                onPressEnter={event => {
                  event.preventDefault()
                  this.props.onSubmit(this.props.question.identifier)
                }}
                innerRef={inputField => {
                  this.input = inputField
                }}
                prefix={<TextIcon>{this.props.currency}</TextIcon>}
                suffix={
                  this.state.isValid != null ? (
                    this.state.isValid ? (
                      <CheckIcon />
                    ) : (
                      <ErrorIcon />
                    )
                  ) : (
                    <span />
                  )
                }
                onChange={this.onValueChange}
              />
            )}
          </FormItem>
        )}
      </div>
    )
  }
}

class InputFieldWrapper extends React.Component {
  handleChange = event => {
    this.props.valueChanged(event)
    this.props.onChange(event)
  }

  render() {
    const { innerRef, ...rest } = this.props
    let errorInfo = {}

    if (this.props["data-__field"].errors) {
      errorInfo = {
        suffix: <ErrorIcon />,
      }
    }
    return (
      <TextInput
        {...rest}
        type="text"
        pattern="\d*"
        onChange={this.handleChange}
        ref={input => innerRef(input)}
        {...errorInfo}
      />
    )
  }
}
